import React, { useEffect, useState } from 'react';
import AppHeader from '../../../components/Dashboard/AppHeader';
import { Content } from 'antd/es/layout/layout';
import { Avatar, Input, Table, Spin, message } from 'antd';
import { SearchOutlined } from "@ant-design/icons";

const StudentDetails = () => {
    const [students, setStudents] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [pageSize, setPageSize] = useState(5); // default limit

    const fetchStudents = async (search = '', page = 1, limit = 5) => {
        setLoading(true);
        try {
            const res = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/getTeacAndStuDetails/student?page=${page}&limit=${limit}&search=${search}`
            );
            const json = await res.json();

            const formattedData = json.data.map((item) => ({
                key: item._id,
                name: item.fullName,
                grade: item.grade,
                parentName: item.parentEmail,
                contact: item.email,
                actions: item.isVerified ? 'Verified' : 'Not Verified',
                profilePic : item.profilePic
            }));

            setStudents(formattedData);
            setTotalPages(json.totalPages);
        } catch (err) {
            message.error('Failed to fetch student data.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStudents(searchText, currentPage, pageSize);
    }, [searchText, currentPage, pageSize]);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
        setCurrentPage(1); // Reset to first page when search changes
    };

    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <div className="flex items-center">
                    <Avatar className="mr-2" src={record.profilePic} />
                    {text}
                </div>
            ),
        },
        { title: 'Grade', dataIndex: 'grade', key: 'grade' },
        { title: 'Parent Email', dataIndex: 'parentName', key: 'parentName' },
        { title: 'Contact (Student Email)', dataIndex: 'contact', key: 'contact' },
        { title: 'Verification', dataIndex: 'actions', key: 'actions' },
    ];

    return (
        <Content>
            <AppHeader
                title="Student Details"
                content="Purpose: Provide a comprehensive view of student details, including parent/guardian information."
            />
            <h3 className="text-xl font-semibold mb-4">Details of Students</h3>
            <div className="border-[2px] border-[black] rounded-[10px] p-3">
                <div className="mb-4 flex space-x-2">
                    <Input
                        placeholder="Search by student name or ID"
                        value={searchText}
                        onChange={handleSearchChange}
                        className="max-w-72 border-2 border-solid border-black"
                        suffix={<SearchOutlined className="text-gray-500" />}
                    />
                </div>
                {loading ? (
                    <Spin />
                ) : (
                    <Table
                        columns={columns}
                        dataSource={students}
                        pagination={{
                            current: currentPage,
                            pageSize: pageSize,
                            total: totalPages * pageSize,
                            showSizeChanger: true,
                            pageSizeOptions: ['1', '5', '10', '20']
                        }}
                        onChange={handleTableChange}
                        scroll={{ x: 'max-content' }}
                        size="small"
                        responsive
                        className="custom-table"
                    />
                )}
            </div>
                        {/* Student Profile Screen */}
            <h3 className="text-xl font-semibold my-4">Student Profile Screen</h3>
            <div className="border-[2px] border-[black] rounded-[10px] p-5 flex flex-col md:flex-row items-center">
                <div className="flex items-center space-x-4 md:w-1/3">
                    <Avatar size={80} src="https://i.pravatar.cc/150?u=charlie.rawal" />
                    <div>
                        <div className="text-lg font-bold">Charlie Rawal</div>
                        <div className="text-gray-500">charlierawal@gmail.com</div>
                    </div>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 py-5 gap-4 my-4 md:mt-0 md:w-2/3">
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">Full Name</label>
                        <Input value="Charlie Rawal" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">Age</label>
                        <Input value="22" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">Parent Name</label>
                        <Input value="Rawal Singh" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">GRADE</label>
                        <Input value="100/72" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">Contact</label>
                        <Input value="0000 000 0000" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">Actions</label>
                        <Input value="250" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                </div>
            </div>
        </Content>
    );
};

export default StudentDetails;
